// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

interface Props {
  size?: number;
  color?: string;
}
export const IconCheckCircle: React.FC<Props> = ({
  size = 24,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12a9 9 0 1 1-3-6.7"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
      />

      <path
        d="M7.3 12.7L10.4 15.8L20.5 6.5"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
